export const supportedLanguageCodes: string[] = ['de', 'en-GB', 'fr'];

export function isLanguageCodeSupported(languageCode: string = ''): boolean {
  return !!supportedLanguageCodes.find((lang) => lang === languageCode);
}
